module.exports = __webpack_public_path__ + "static/media/s1.7b827e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/s1.jpg
// module id = 404
// module chunks = 0